import { api } from 'agent';
import { UploadDTO } from './dto/UploadDTO';
import { UploadNewStatus } from './dto/UploadNewStatus';

export default function getUploadById(id: number): Promise<UploadDTO> {
  return api.get(`upload/${id}`).then((response: { data: UploadDTO }) => response.data);
}

export function getNewUploadVersion(inspectionSummaryFileName: string): Promise<number> {
  return api
    .get(`/upload/version/${inspectionSummaryFileName}`)
    .then((response: { data: number }) => response.data);
}

export function changeFileSetStatus(uploadNewStatus: UploadNewStatus): Promise<void> {
  return api.post(`upload/${uploadNewStatus.id}/statusChange`, {
    status: uploadNewStatus.status.key,
    reason: uploadNewStatus.reason,
  });
}

export function deleteUpload(id: number): Promise<void> {
  return api.delete(`upload/${id}`);
}
